/**
 * Utility function to merge classNames conditionally
 * @param {...(string|object|undefined)} classes - Class names or objects with boolean values
 * @returns {string} Merged class names
 */
export const cn = (...classes) => {
  return classes
    .filter(Boolean)
    .map((cls) => {
      if (typeof cls === 'string') return cls;
      if (typeof cls === 'object' && cls !== null) {
        return Object.entries(cls)
          .filter(([, value]) => Boolean(value))
          .map(([key]) => key)
          .join(' ');
      }
      return '';
    })
    .filter(Boolean)
    .join(' ');
};

export default cn;























